import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AmplitudeService } from '../../shared/services/amplitude.service';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'cc-lg-creator-select',
  templateUrl: './creator-select.component.html',
  styleUrls: ['./creator-select.component.scss']
})
export class CreatorSelectComponent implements OnInit {
  public chooseForm: FormGroup;
  public projectId: number;

  constructor(private fb: FormBuilder, private amplitudeService: AmplitudeService, private route: ActivatedRoute) {
    this.amplitudeService.logEvent('Panel: Page View: Lead Generation Choice Page');
  }

  ngOnInit() {
    this.projectId = +this.route.parent.parent.snapshot.paramMap.get('projectId');
    this.createForm();
  }

  createForm(): any {
    this.chooseForm = this.fb.group({
      creatorType: [null, Validators.required]
    });
  }

  isActive(type) {
    return this.chooseForm.get('creatorType').value === type;
  }
}
